<template>
  <div class="w-screen h-screen bg-primary-500 text-white flex items-center justify-center">
    <div>
      <div class="relative w-40 h-32 flex items-center justify-center overflow-hidden pt-4">
        <icon
          class="animation-jump animation-2s"
          name="WaldigLogo"
          size="5em"
          :settings="{strokeWidth: .6, circle: false}"
        />
        <div class="absolute inset-0 w-40 h-40 border border-white rounded-full"></div>
      </div>
      <div class="mt-3 text-center">
        <span class="uppercase tracking-widest font-medium text-2xl">Stupsi</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Splash",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {},
  computed: {},
  created() {}
};
</script>